import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import {ContactusService} from "../../_services/contactus.service";

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-add-organization-url',
  templateUrl: './add-organization-url.component.html',
  styleUrls: ['./add-organization-url.component.css']
})
export class AddOrganizationUrlComponent implements OnInit {
  addGstForm: FormGroup;
  submitted = false;
  returnUrl: string;
  userdetaild: string;

  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private contactusservice: ContactusService, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    this.addGstForm = this.formBuilder.group({
      page: ['', [Validators.required]],
      slug: ['', [Validators.required]],
      status: ['true', [Validators.required]],
    });
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }

  get f() { return this.addGstForm.controls; }

  onSubmit() {
    this.submitted = true;
    this.spinnerService.show();
    // stop here if form is invalid
    if (this.addGstForm.invalid) {
      this.spinnerService.hide();
      return;
    }

    const addPayload = {
      page: this.addGstForm.controls.page.value,
      slug: this.addGstForm.controls.slug.value,
      status: this.addGstForm.controls.status.value,
    };

    this.addOrganizationPage(addPayload);

    // console.log('message',addPayload);

  }

  addOrganizationPage(payload) {
    this.contactusservice.addOrganizationPage(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.spinnerService.hide();
            this.router.navigate([`/organization-url`]);
          } else {
            this.spinnerService.hide();
            this.toaster.showError('Add URL', data.ResponseMessage);
          }
        },
        error => {
          this.spinnerService.hide();
          this.toaster.showError('Add URL', error);
        });
  }


}
